import { makeStyles } from '@material-ui/core/styles';

export const useStyle = makeStyles((theme) => {
    return {
        actions: {
            padding: '18px 24px',
        },
        button: {
            height: 60,
            fontSize: 20,
            textTransform: 'none',
            [theme.breakpoints.down('md')]: {
                height: 50,
                fontSize: 16,
            },
        },
    };
});
